<template>
  <div>
    <h2>Results</h2>
    <p>{{ result }}</p>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  data() {
    return {
      result: null
    }
  },
  created() {
    axios.get('/api/results')
      .then(response => {
        this.result = response.data;
      })
  }
}
</script>
